import React from 'react';
export function Footer() {
  return <footer className="w-full py-16 px-8 bg-slate-50 border-t border-slate-200" data-id="element-113">
      <div className="max-w-7xl mx-auto" data-id="element-114">
        <div className="grid md:grid-cols-3 gap-12 mb-12" data-id="element-115">
          {/* Logo and description */}
          <div className="space-y-4" data-id="element-116">
            <div className="flex items-center gap-3" data-id="element-117">
              <div className="w-8 h-8 flex-shrink-0" data-id="element-118">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/njTUoX7DVWPKz91wtv3CVR/PCC_BGR2.png" alt="Pericles Capital" className="w-full h-full object-contain" data-id="element-119" />
              </div>
              <div data-id="element-120">
                <div className="text-xl font-bold text-slate-900" data-id="element-121">
                  Pericles Capital
                </div>
                <div className="text-xs text-slate-600 font-medium" data-id="element-122">
                  QUANTITATIVE RESEARCH LAB
                </div>
              </div>
            </div>
            <p className="text-sm text-slate-600 leading-relaxed" data-id="element-123">
              An independent student research organization exploring
              quantitative finance and unconventional market strategies.
            </p>
          </div>
          {/* Quick Links */}
          <div data-id="element-124">
            <h3 className="text-sm font-bold text-slate-900 mb-4 uppercase tracking-wider" data-id="element-125">
              Quick Links
            </h3>
            <ul className="space-y-2" data-id="element-126">
              <li data-id="element-127">
                <a href="#about" className="text-sm text-slate-600 hover:text-slate-900 transition-colors" data-id="element-128">
                  About
                </a>
              </li>
              <li data-id="element-129">
                <a href="#apply" className="text-sm text-slate-600 hover:text-slate-900 transition-colors" data-id="element-130">
                  Apply
                </a>
              </li>
            </ul>
          </div>
          {/* Contact */}
          <div data-id="element-131">
            <h3 className="text-sm font-bold text-slate-900 mb-4 uppercase tracking-wider" data-id="element-132">
              Contact
            </h3>
            <a href="mailto:hello@pericles.capital" className="text-sm text-slate-600 hover:text-slate-900 transition-colors" data-id="element-133">
              hello@pericles.capital
            </a>
          </div>
        </div>
        <div className="pt-8 border-t border-slate-200 text-center" data-id="element-134">
          <p className="text-sm text-slate-600" data-id="element-135">
            © {new Date().getFullYear()} Pericles Capital. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}